import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { SaveOutlined } from "@ant-design/icons";
import classname from "classname";

const Save = ({
  id = "btn-save",
  title,
  icon = <SaveOutlined />,
  type = "primary",
  onClick = () => {},
  className,
  defaultClassName = true,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.save");

  return (
    <Button
      className={
        defaultClassName
          ? classname(
              "flex items-center justify-center hover:opacity-70",
              className
            )
          : ""
      }
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Save);
